export const SET_ISDEDICATED_WORKFLOW = 'SET_ISDEDICATED_WORKFLOW';
